@if (isHome || listingPage) {
  @defer (hydrate on hover) {

    <div class="p-card horizontal" [class.home-page]="isHome" [class.selected]="activeId === property?._id">
      <div class="property-row flex">

        @if (!isHome) {
          <div class="wish-list-button">
            <app-wish-list-button [propertyId]="property?._id"></app-wish-list-button>
          </div>
        }
        <div class="img-wrapper">
          <!--        @if (property?.imageList) {-->
          <a style="display: block" href="https://listings.satel.sa/property/{{property?.propertyNumber}}">
          <span class="p-label"
                style="z-index: 99"
                [class.villas]="property.subCatName === 'Villas'"
                [class.apartments]="property.subCatName === 'Apartments'"
                [class.compounds]="property.subCatName === 'Compounds'">{{ property?.subCatName }}</span>
            @if (property?.labelText) {
              <span class="p-label new"
                    style="z-index: 99">{{ property?.labelText }}</span>
            }
          <swiper-container pagination="true"
                            pagination-clickable="true">
            @for (img of property?.imageListGallery; track img) {
              <swiper-slide>
                <ion-img [src]="img.filepath" [alt]="'Satel | ' + ('property.properties' | translate) + ' ' + ('property.where_you_live' | translate)"></ion-img>
              </swiper-slide>
            }
          </swiper-container>
          </a>
          <!--        }-->
        </div>
        <!--      property?.catName, property?.subCatName, property?.titleEn-->
        <a href="https://listings.satel.sa/property/{{property?.propertyNumber}}">
          <div class="property-content-wrapper">
            <div class="p-2-content">
              <span class="p-number">{{property?.propertyNumber}}</span>
              <div>
                <h1 class="p-title">
                  {{  languageService.lang() === 'en' ? property?.titleEn : property?.titleAr }}
                </h1>
                <span class="p-location"><ion-icon name="location-outline"></ion-icon> {{ languageService.lang() === 'en' ? property?.address?.subCityEn : property?.address?.subCityAr }}, {{ languageService.lang() === 'en' ? property?.address?.cityEn : property?.address?.cityAr }}</span>
              </div>
              @if (innerCard) {
                <div class="p-features">
                  <span>{{ property?.beds }} {{ 'property.bedrooms' | translate }}</span>
                  <span>{{ property?.baths }} {{ 'property.bathrooms' | translate }}</span>
                  <span>{{ property?.floorArea }} {{ 'property.sq_m' | translate }}</span>
                </div>
              } @else if (isHome) {
                <div class="p-features">
          <span>
          <ion-icon src="assets/icons/icon-bed.svg"></ion-icon>
            {{ property?.beds }}
          </span>
                  <span>
          <ion-icon src="assets/icons/icon-bath.svg"></ion-icon>
                    {{ property?.baths }}
          </span>
                  <span>
          {{ property?.floorArea }} {{ 'property.sq_ft' | translate }}
          </span>
                </div>
              }

              <span class="p-price">
          <span>{{ property?.newPrice | currency: currencyConvertService.localCurrency() + ' ' }}</span>
        </span>
            </div>
          </div>
        </a>
      </div>
    </div>
  }
} @else {
  <div class="p-card inner" [class.inner]="innerCard" [class.horizontal]="isHome">
    <div class="img-wrap">
      @if (property?.imageList) {
        <span class="p-location">
          <ion-icon name="location"></ion-icon> {{ property?.address?.subCityEn }}</span>
        <span class="p-label">{{ property?.subCatName }}</span>
        @if (isWishlist()) {
          <ion-buttons>
            <ion-button (click)="updateWishList(property?._id)" color="danger" aria-label="Add to wishlist">
              <ion-icon [name]="isInWishlist ? 'heart' : 'heart-outline'"></ion-icon>
            </ion-button>
          </ion-buttons>
        }
        <ion-img [src]="property?.imageList.length ? property?.imageList[0].filepath : ''" [alt]="'Satel | ' + ('property.properties' | translate) + ' ' + ('property.where_you_live' | translate)"></ion-img>
      }
    </div>
    <div class="p-content">
      <span class="p-title">{{  property?.titleEn }}</span>

      <div class="p-features">
        <ion-icon src="assets/icons/icon-bed.svg"></ion-icon>
        <span>{{ property?.beds }}</span>
        <ion-icon src="assets/icons/icon-bath.svg"></ion-icon>
        <span>{{ property?.baths }}</span>
      </div>
      <span class="p-price">
          {{ property?.newPrice | currency: currencyConvertService.localCurrency() + ' ' }}
        </span>
    </div>
</div>

}
